import { Injectable } from '@angular/core';
import { COUNTRY_CODE } from '../constants/country';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IGeoLocation } from '../interfaces/utils.interface';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class GeoLocationService {
  constructor(private api: ApiService) {
  }

  searchPlaces(params: { countryCode: COUNTRY_CODE | string, locale: string, address: string }): Observable<string[]> {
    const { countryCode, locale, address } = params;

    return this.api.get('api.location', 'gmaps_places_autocomplete', null, {
      params: {
        address, locale,
        country_code: countryCode,
        types: ['address', 'establishment', 'geocode'],
      }
    })
      .pipe(map((res) => res.map(({ description }) => description)));
  }

  getLocationInfo(address: string, locale: string): Observable<IGeoLocation> {
    return this.api
      .get('api.location', 'location_info', null, { params: { address, locale } });
  }
}
